export default __webpack_public_path__ + "static/media/lobby-bg.5b510335.png";